<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
              @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_user_app']">
              <a-select v-model="queryParam.app"
                        :placeholder="language['common.pleaseChoose'] + language['gift_user_app']"
                        :options="appList"
                        @change="handlerApp"  :disabled='appLimit.flag'  >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_tag_name']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_tag_name']"
                       v-model="queryParam.label"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <span style="float: left;overflow: hidden;"
                  class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="searchQuery"
                        icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary"
                        @click="searchReset"
                        icon="reload"
                        style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd"
                type="primary"
                icon="plus"  v-has="'tag:add'">{{language['common.insertButton']}}</a-button>
      <a-button type="primary"
                icon="download"
                @click="handleExportXls('商品標籤列表')" v-has="'tag:export'">{{language['common.exportButton']}}</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"
                       @click="batchDel">
            <a-icon type="delete" />{{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px" v-has="'tag:delete'"> {{language['common.batchAction']}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info"
           style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>  {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px"
           @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table ref="table"
               size="middle"
               :scroll="{x:true}"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="false"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               class="j-table-force-nowrap"
               @change="handleTableChange">

        <span slot="action"
              slot-scope="text, record">
          <div v-if="record.approveStatus === '0'">
            <a @click="handlePassAndRefuse(record,1)">{{language['gift_vendor_pass']}}</a>
            <a-divider type="vertical" />
            <a @click="handlePassAndRefuse(record,2)">{{language['common.reject']}}</a>
          </div>
          <div v-else>
            <a @click="handleEdit(record)" v-has="'tag:edit'">{{language['common.edit']}}</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}}
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
                </a-menu-item>
                <a-menu-item v-if="record.status === 0"  v-has="'tag:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']"
                                @confirm="() => handleDelete(record.id)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </span>

        <span slot="switchSlot"
              slot-scope="status, record, idx">
            <a-switch :checked='status' @click='changeStatus(status,record, idx)' />
        </span>

      </a-table>
    </div>

    <product-tag-modal ref="modalForm"
                       @ok="modalFormOk"
                       :appList="appList"></product-tag-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import ProductTagModal from './modules/ProductTagModal'
import { httpAction, getAction,postAction } from '@/api/manage'

export default {
  name: 'GiftVendorList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    ProductTagModal,
  },
  data() {
     const language = this.$store.getters.language
    return {
      disableMixinCreated: true,
      description: 'gift_vendor管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: language['gift_tag_name'],
          align: 'center',
          dataIndex: 'label',
        },
        {
          title: language['gift_tag_group'],
          align: 'center',
          dataIndex: 'groupName',
        },
        {
          title: language['common.sort'],
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: language['gift_user_app'],
          align: 'center',
          dataIndex: 'appName',
        },
        {
          title: language['serial.activeFlag'],
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'switchSlot' },
        },
        {
          title: language['common.action'],
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/carnival/product/tag/list',
        delete: '/carnival/product/tag/delete',
        deleteBatch: '/carnival/product/tag/deleteBatch',
        exportXlsUrl: '/carnival/product/tag/export',
        importExcelUrl: '/carnival/product/tag/import',
        passAndRefuseUrl: '/carnival/product/tag/passAndRefuse',
        appListUrl: '/carnival/app/list',
        turnStatus:'/carnival/product/tag/turnStatus',
        checkAppLimit: '/carnival/app/checkAppLimit/code',
      },
      dictOptions: {},
      superFieldList: [],
      appList: [],
      appLimit:{
        flag: false,
        value: undefined
      }
    }
  },
  created() {
    this.checkAppLimit();
    this.getAppListByStatus()
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
     language() {
      return this.$store.getters.language
    },
  },
  methods: {
    searchReset(){
      if (this.appLimit.flag){
        this.queryParam.label = undefined;
      }else {
        this.queryParam = {};
      }
      this.loadData(1);
    },
    async checkAppLimit(){
      await getAction(this.url.checkAppLimit).then(res=>{
        if (res.success){
          this.appLimit.flag = true;
          this.queryParam.app = res.result;
        }
      })
      this.loadData(1);
    },
    getAppListByStatus() {
      var params = {
        status: 1,
        order: 'desc',
        pageNo: 1,
        pageSize: 99999,
      }
      getAction(this.url.appListUrl, params).then((res) => {
        if (res.success) {
          //update-begin---author:zhangyafei    Date:20201118  for：适配不分页的数据列表------------
          const result = res.result.records || res.result
          this.appList = result.map((item, index, arr) => {
            let c = { label: item.name, value: item.code + '' }
            return c
          })
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handlePassAndRefuse(record, approveStatus) {
      record.approveStatus = approveStatus
      httpAction(this.url.passAndRefuseUrl, record, 'put').then((res) => {
        if (res.success) {
          this.searchQuery()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    changeStatus(checked,record, idx) {
      console.log("data",this.dataSource);
        console.log("checked",checked);
      postAction(this.url.turnStatus,record).then((res)=>{
            if (res.success){
              // this.loadData();
              if (this.dataSource[idx]) this.dataSource[idx].status = checked === 0 ? 1 : 0;
              return true;
            }else {
              this.$message.error(res.message);
              return false;
            }
         })
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'string', value: 'vendorCode', text: '供应商编码' })
      fieldList.push({ type: 'string', value: 'vendorName', text: '供应商名称' })
      fieldList.push({ type: 'string', value: 'status', text: '1:上架；0：下架；' })
      fieldList.push({ type: 'string', value: 'industry', text: '所属行业' })
      fieldList.push({ type: 'string', value: 'contactPerson', text: '联系人' })
      fieldList.push({ type: 'string', value: 'contactPhone', text: '联系电话' })
      fieldList.push({ type: 'number', value: 'commission', text: '抽佣比例' })
      fieldList.push({ type: 'string', value: 'paymentDays', text: '账期' })
      fieldList.push({ type: 'string', value: 'address', text: '商户地址' })
      fieldList.push({ type: 'string', value: 'desc', text: '商户简介' })
      fieldList.push({ type: 'string', value: 'logo', text: 'logo图片' })
      fieldList.push({ type: 'string', value: 'certificate', text: '营业执照图片' })
      fieldList.push({ type: 'string', value: 'delFlag', text: '是否删除' })
      this.superFieldList = fieldList
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
